<div class="main-header-left d-none d-lg-block">

  <div class="logo-wrapper">
    <a [routerLink]="'/dashboard'"><img class="blur-up lazyloaded"
           src="assets/images/dashboard/swayam.png"
           class="w-100"
           alt=""></a>
  </div>
</div>
<div class="sidebar custom-scrollbar">
  <div class="sidebar-user text-center">
    <!--   <div><img class="img-60 rounded-circle"
           src="assets/images/dashboard/swayam.png"
           alt="#">
    </div> -->
    <div class="d-flex justify-content-center ">
      <div class="media align-items-center text-uppercase">
        <h6 class="mb-0">{{parentData?.email?.slice(0, 2) }}</h6>
      </div>
    </div>
    <h6 class="mt-3 f-14">{{parentData?.first_name }} {{parentData?.last_name }}</h6>
    <button type="button"
            [routerLink]="['/add-child']"
            (click)="collapseSidebar()"
            class="btn btn-primary">Add Child</button>
    <!-- <a href="javascript:void(0)"
       [routerLink]="['/add-child']"
       routerLinkActive="router-link-active"
       class="sidebar-header">
      Add Child
    </a> -->
  </div>


  <ul class="sidebar-menu">
    <li>
      <a href="javascript:void(0)"
         [routerLink]="['/dashboard']"
         (click)="collapseSidebar()"
         routerLinkActive="router-link-active"
         class="sidebar-header">
        <app-feather-icons icon="home"></app-feather-icons> Home
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         [routerLink]="['/home']"
         (click)="collapseSidebar()"
         routerLinkActive="router-link-active"
         class="sidebar-header">
        <app-feather-icons icon="smartphone"></app-feather-icons> Screen Time
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         (click)="collapseSidebar()"
         [routerLink]="['/manage-device']"
         routerLinkActive="router-link-active"
         class="sidebar-header">
        <!-- <i class="fa-solid fa-ban  me-1"></i> -->
        <app-feather-icons icon="slash"></app-feather-icons> Block Apps
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         (click)="collapseSidebar()"
         [routerLink]="['/location-logs']"
         routerLinkActive="router-link-active"
         class="sidebar-header">
        <!-- <i class="fa-solid fa-clock-rotate-left me-1"></i> -->
        <app-feather-icons icon="tag"></app-feather-icons> Location History
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         (click)="collapseSidebar()"
         [routerLink]="['/live-location']"
         routerLinkActive="router-link-active"
         class="sidebar-header">
        <!-- <i class="fa-solid fa-location-dot me-1"></i> -->
        <app-feather-icons icon="map-pin"></app-feather-icons> Live Location
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         (click)="collapseSidebar()"
         [routerLink]="['/mood-timeline']"
         routerLinkActive="router-link-active"
         class="sidebar-header">
        <app-feather-icons icon="smile"></app-feather-icons> Mood Timeline
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         [routerLink]="['/call-page/sms/list']" 
         routerLinkActive="router-link-active"
         class="sidebar-header d-flex">
        <app-feather-icons icon="message-square"></app-feather-icons> {{childName}} SMS
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
      [routerLink]="['/call-page/contact']" 
         routerLinkActive="router-link-active"
         class="sidebar-header  d-flex">
        <app-feather-icons icon="user"></app-feather-icons> {{childName}} Contacts
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
      [routerLink]="['/call-page/logs']" 
         routerLinkActive="router-link-active"
         class="sidebar-header d-flex">
        <app-feather-icons icon="phone"></app-feather-icons> {{childName}} Logs
      </a>
    </li>
    <li class="mt-m-5">
      <a target="_blank"
         (click)="collapseSidebar()"
         href="https://docs.google.com/forms/d/e/1FAIpQLSeN2b-dt_i_aa6Axx4HVOBm3bbYfjQD6TzY-Xk3zR8OiZU7Sw/viewform">
        <button type="button"
                class="btn btn-primary">Report Problem</button>
      </a>

    </li>
    <li>
      <a (click)="shareLink()"
         role="button"
         role="button"
         class="sidebar-header">
        <app-feather-icons icon="share-2"></app-feather-icons> Share
      </a>
    </li>
    <li>
      <a href="javascript:void(0)"
         class="sidebar-header"
         [routerLink]="'/get-help'">
        <app-feather-icons [icon]="'settings'"></app-feather-icons><span>
          Get Help</span>
      </a>
    </li>
    <li>
      <a (click)="openConfirm()"
         href="javascript:void(0)"
         class="sidebar-header">
        <app-feather-icons [icon]="'log-out'"></app-feather-icons><span class="ms-1">Logout</span>
      </a>
    </li>

  </ul>

  <!--  <ul class="sidebar-menu">
    <li *ngFor="let menuItem of menuItems"
        [ngClass]="{active: menuItem.active}">
      <a href="javascript:void(0)"
         class="sidebar-header"
         *ngIf="menuItem.type === 'sub'"
         (click)="toggletNavActive(menuItem)">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
                class="badge badge-{{menuItem.badgeType}} ms-3"
                *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right"
           *ngIf="menuItem.children"></i>
      </a>
      <a [routerLink]="!menuItem.type ? null : [menuItem.path]"
         routerLinkActive="active"
         class="sidebar-header"
         *ngIf="menuItem.type === 'link'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
                class="badge badge-{{menuItem.badgeType}} ms-3"
                *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right"
           *ngIf="menuItem.children"></i>
      </a>
      <a href="{{ !menuItem.type ? null : menuItem.path }}"
         class="sidebar-header"
         *ngIf="menuItem.type === 'extLink'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
                class="badge badge-{{menuItem.badgeType}} ms-3"
                *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right"
           *ngIf="menuItem.children"></i>
      </a>
      <a href="{{ !menuItem.type ? null : menuItem.path }}"
         target="_blank"
         class="sidebar-header"
         *ngIf="menuItem.type === 'extTabLink'">
        <app-feather-icons [icon]="menuItem.icon"></app-feather-icons><span>{{menuItem.title}}<span
                class="badge badge-{{menuItem.badgeType}} ms-3"
                *ngIf="menuItem.badgeType">{{menuItem.badgeValue}}</span></span>
        <i class="fa fa-angle-right pull-right"
           *ngIf="menuItem.children"></i>
      </a>
      <ul class="sidebar-submenu"
          [ngClass]="{'menu-open': menuItem.active, 'menu-close': !menuItem.active }"
          *ngIf="menuItem.children">
        <li *ngFor="let childrenItem of menuItem.children"
            [ngClass]="{active: childrenItem.active}">
         
          <a href="javascript:void(0)"
             *ngIf="childrenItem.type === 'sub'"
             (click)="toggletNavActive(childrenItem)">
            <i class="fa fa-circle"></i><span> {{childrenItem.title}} <span
                    class="badge badge-{{childrenItem.badgeType}} pull-right"
                    *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span> </span>
            <i class="fa fa-angle-down pull-right"
               *ngIf="childrenItem.children"></i>
          </a>
          
          <a [routerLink]="!childrenItem.type ? null : [childrenItem.path]"
             *ngIf="childrenItem.type === 'link'"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}">
            <i class="fa fa-circle"></i><span>{{childrenItem.title}} <span
                    class="badge badge-{{childrenItem.badgeType}} pull-right"
                    *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span></span>
            <i class="fa fa-angle-down pull-right"
               *ngIf="childrenItem.children"></i>
          </a>
          <a href="{{ !childrenItem.type ? null : childrenItem.path }}"
             *ngIf="childrenItem.type === 'extLink'"
             routerLinkActive="active"
             [routerLinkActiveOptions]="{exact: true}">
            <i class="fa fa-circle"></i><span>{{childrenItem.title}} <span
                    class="badge badge-{{childrenItem.badgeType}} pull-right"
                    *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span></span>
            <i class="fa fa-angle-down pull-right"
               *ngIf="childrenItem.children"></i>
          </a>
          <a href="{{ !childrenItem.type ? null : childrenItem.path }}"
             target="_blank"
             *ngIf="childrenItem.type === 'extTabLink'">
            <i class="fa fa-circle"></i><span>{{childrenItem.title}} <span
                    class="badge badge-{{childrenItem.badgeType}} pull-right"
                    *ngIf="childrenItem.badgeType">{{childrenItem.badgeValue}}</span></span>
            <i class="fa fa-angle-down pull-right"
               *ngIf="childrenItem.children"></i>
          </a>
        
          <ul class="sidebar-submenu"
              *ngIf="childrenItem.children">
            <li *ngFor="let childrenSubItem of childrenItem.children">
            
              <a [routerLink]="!childrenSubItem.type ? null : [childrenSubItem.path]"
                 *ngIf="childrenSubItem.type === 'link'"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-circle"></i><span> {{childrenSubItem.title}} <span
                        class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                        *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span> </span>
              </a>
              <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}"
                 *ngIf="childrenSubItem.type === 'extLink'"
                 routerLinkActive="active"
                 [routerLinkActiveOptions]="{exact: true}">
                <i class="fa fa-circle"></i><span>{{childrenSubItem.title}} <span
                        class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                        *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span></span>
              </a>
              <a href="{{ !childrenSubItem.type ? null : childrenSubItem.path }}"
                 target="_blank"
                 *ngIf="childrenSubItem.type === 'extTabLink'">
                <i class="fa fa-circle"></i><span>{{childrenSubItem.title}} <span
                        class="badge badge-{{childrenSubItem.badgeType}} pull-right"
                        *ngIf="childrenSubItem.badgeType">{{childrenSubItem.badgeValue}}</span></span>
              </a>
            </li>
          </ul>
        </li>
      </ul>
    </li>
  </ul> -->

</div>